import { createStore } from 'vuex'
import auth from './modules/auth'
import indicadores from './modules/indicadores'

export default createStore({
  modules: {
    auth,
    indicadores
  }
})